import { postForm } from '@/shared/api/client';
import { getListRows } from '@/shared/lib/pagination';

export interface RefItem extends Record<string, unknown> {
  id: string | number;
  name?: string;
  code?: string;
}

export interface BidsListParams {
  page: number;
  sort_field: string;
  status_id: string | number;
  id: string;
  description: string;
  work_type_name: string;
  country_id: string;
  region_id?: string;
  city_id: string;
  type_id: string;
  request_type: string;
  mark_id: string;
  model_id: string;
  need_evacuator: string;
  source: string;
  partner_id: string;
  utm_id: string;
  work_order: string;
  cost: string;
  promo_code: string;
  changed_cost_only: number | '';
  create_time_from: number | '';
  create_time_to: number | '';
  repair_time_from: number | '';
  repair_time_to: number | '';
}

export function fetchBidsList(params: BidsListParams) {
  return postForm<Record<string, unknown>>('/bid/list/', { ...params });
}

export async function fetchCarTypes() {
  const res = await postForm<Record<string, unknown>>('/car/type/list/', {});
  return getListRows<RefItem>(res, ['types', 'items']);
}

export async function fetchCarMarks(typeId: string) {
  const res = await postForm<Record<string, unknown>>('/car/mark/list/', { type_id: typeId, page: 0 });
  return getListRows<RefItem>(res, ['marks', 'items']);
}

export async function fetchCarModels(markId: string) {
  const res = await postForm<Record<string, unknown>>('/car/model/list/', { mark_id: markId, page: 0 });
  return getListRows<RefItem>(res, ['models', 'items']);
}

/** Loyalty filter options. `promo_id=1` is legacy `PROD_PROMOCODE`. */
export async function fetchPromoCodes() {
  const res = await postForm<Record<string, unknown>>('/billing/billing-promo-code/index/', {
    page: 1,
    promo_id: 1,
  });
  return getListRows<RefItem>(res, ['items']);
}

export function showBidCustomerPhone(userId: string | number) {
  return postForm<{ success: number; phone?: string }>('/user/profile/show-phone/', { user_id: userId });
}

/** Call-center operator shift status (`0` = idle, `1` = working). */
export function fetchOperatorWorkStatus(operatorId: string | number) {
  return postForm<{ success?: number; status?: number }>('/callcenter/operator/get-status/', {
    operator_id: operatorId,
  });
}

export function startOperatorWork() {
  return postForm<{ success?: number }>('/callcenter/operator/start-work/', {});
}

export function finishOperatorWork() {
  return postForm<{ success?: number }>('/callcenter/operator/finish-work/', {});
}
